import EntityCta from "./EntityCta"
import { observer } from "mobx-react-lite"
import { store } from "../../../../stores/Store"
import EntityDetailSection from "./EntityDetailSection"
import { flattenNode } from "../../../../misc/nodeFlattener"
import Panel from "../../../layout/Panel"
import PanelLabel from "../../../layout/PanelLabel"
import PanelHeader from "../../../layout/PanelHeader"
import PanelBody from "../../../layout/PanelBody"
import { DetailPanelProps } from "./DetailPanel"
import JobSection from "./JobSection"
import { Button } from "@mui/material"
import { AlertModal } from "../../../.."
import JobSelectField from "../../../form/JobSelectField"
import Ajax from "../../../../Ajax"
import React from "react"
import { format } from "date-fns"
import JobDatesSection from "./JobDatesSection"


export default observer(function EntityDetail ({index}: DetailPanelProps) {

    const { leafNode, loadingLeafNode, setLeafNode } = store.NodeStore

    const flattenedNode = flattenNode(leafNode)
    var leftColumnSections = flattenedNode.sections.filter((s, i) => (i < (flattenedNode.sections.length/2)) || s.uid.includes("ATTRS"))
    var rightColumnSections = flattenedNode.sections.filter((s, i) => !(i < (flattenedNode.sections.length/2)) && !s.uid.includes("ATTRS"))

    if (leafNode?.uid.includes("SPONSOR")) {
        leftColumnSections = [...leftColumnSections, ...rightColumnSections]
        rightColumnSections = []
    }

    return (
        <Panel index={index} id="DETAIL" className="detail" width="100%" loadingContent={loadingLeafNode}>

            <PanelLabel title="Details" />

            <PanelHeader node={leafNode} closeable onClose={() => setLeafNode(null)}>
                <EntityCta entity={leafNode} />
            </PanelHeader>

            <PanelBody>
                <div className="panel-columns">
                    <div className="panel-column">
                        {leafNode?.uid.includes("JOB") ? (
                            <JobDatesSection jobNode={leafNode} />
                        ) : null}

                        {leftColumnSections.map((section: any, section_index: number) => <EntityDetailSection entityUid={leafNode.uid} key={section_index} section={section} />)}
                    </div>
                    
                    <div className="panel-column">
                        {leafNode?.uid.includes("SPONSOR") ? (
                            <div style={{display: "grid", gap: "5px", marginTop: "10px"}}>
                                <h4>All Jobs under this Sponsor</h4>

                                <JobSelectField accountUid={leafNode.uid.replace("SPONSOR", "ACCOUNT")} />
                            </div>
                        ) : null}

                        {rightColumnSections.map((section: any, section_index: number) => <EntityDetailSection entityUid={leafNode.uid} key={section_index} section={section} />)}
                    </div>
                </div>
            </PanelBody>

        </Panel>
    )
})